import { useState, useEffect } from "react";
import { saveItemGroup, getAllItemTypes } from "../Api/ItemGroup";
import {
  Accordion,
  AccordionItem,
  AccordionBody,
  Form,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const ItemGroup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [itemTypes, setItemTypes] = useState([]);

  const [itemGroupData, setItemGroupData] = useState({
    code: "",
    description: "",
    itemType: "",
  });

  useEffect(() => {
    const fetchItemTypes = async () => {
      try {
        const types = await getAllItemTypes();
        setItemTypes(types);
      } catch (error) {
        toast.error("🦄 Error loading item types!");
      }
    };
    fetchItemTypes();
  }, []);

  const handleChange = (e) => {
    setItemGroupData({ ...itemGroupData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveItemGroup(itemGroupData);
      toast.success("🦄 Item Group Added Successfully");
      setItemGroupData({ code: "", description: "", itemType: "" });
      navigate("/viewItemGroups"); // optional view page
    } catch (error) {
      toast.error("🦄 Error saving Item Group!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container item-group-fields">
        <h2 className="fields-title">Item Group</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion defaultActiveKey="0" className="item-group-accordion">
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="code"
                        value={itemGroupData.code}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Description <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={itemGroupData.description}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Item Type <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="itemType"
                        value={itemGroupData.itemType}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Item Type</option>
                        {itemTypes.map((type, index) => (
                          <option key={index} value={type.code}>
                            {type.code} - {type.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button variant="primary" type="submit" className="fields-submit">
              Save Item Group
            </Button>
          </div>
        </Form>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ItemGroup;
